// Turn any link pointing at a Calendly scheduling page into a popup widget
// instead of a full navigation, once Calendly's own script (added via Ghost's
// Code Injection) has loaded. Falls back to a normal link if that script
// isn't present, so the button never silently does nothing.
export default function calendlyPopup() {
    const triggers = document.querySelectorAll('a[href*="calendly.com"]');

    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
            if (typeof window.Calendly === 'undefined') {
                return;
            }
            event.preventDefault();
            window.Calendly.initPopupWidget({url: trigger.href});
        });
    });
}
